import { useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';

export const useScheduledConsultId = () => {
  const [searchParams] = useSearchParams();
  const scheduledConsultId = useMemo(() => {
    const scheduledConsult = searchParams.get('scheduledConsult');
    return scheduledConsult ? Number(scheduledConsult) : undefined;
  }, [searchParams]);

  return scheduledConsultId;
};
